import { SITE_URL } from "../common/constants"

export const PAY_BASE = "/pay/"

export const PAY_LINKS = {
  faq: `${PAY_BASE}faq/`,
  account: `${PAY_BASE}account/`,
  submit: `${PAY_BASE}submit/`,
  payment: `${PAY_BASE}payment/`,
}

export const INTERVIEW_LINK = "/symptom-checker/"

export const TERMS_URL = `${SITE_URL}/terms/`
export const PRIVACY_URL = `${SITE_URL}/privacy/`
export const SYMPTOMS_URL = `${SITE_URL}/symptoms-a-z/`



// WEBPACK FOOTER //
// ./assets/payment/constants.js